export interface AppConfig {
  CMS_API_URL: string;
  CMS_FILE_API_URL: string;
  CMS_API_PUBLIC_KEY: string;
  TENANT_NAME: string;
  NEWSLETTER_FORM_KEY: string;
}

const isValidUrl = (value: string): boolean => {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

export const hasValidCmsConfig = (config: AppConfig): boolean => {
  return Boolean(
    isValidUrl(config.CMS_API_URL) &&
    isValidUrl(config.CMS_FILE_API_URL) &&
    config.CMS_API_PUBLIC_KEY &&
    config.TENANT_NAME
  );
};

export const hasValidNewsletterConfig = (config: AppConfig): boolean => {
  return Boolean(
    isValidUrl(config.CMS_API_URL) &&
    config.TENANT_NAME &&
    config.NEWSLETTER_FORM_KEY
  );
};
